import { sections } from "./sections";

export const getSearchQueryCredits = (plan: string): string | number => {
  const searchQueriesSection = sections
    .find((section) => section.name === "Usage")
    .features.find((feature) => feature.name === "Search Queries");
  const credits = searchQueriesSection.tiers[plan];
  return credits === "Unlimited" ? "Unlimited" : parseInt(credits);
};
